import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';
import { selectFilterProfiles } from '../selectors/filters';

export const initialFilterState = {
  profilesLoadStatus: STATUS.IDLE,
  profiles: [],
  selectedProfile: null,
  appliedProfile: null,
  dropdownSelectedProfile: null,
  originalFilterProfiles: null,
  deleteProfileStatus: STATUS.IDLE,
};

export default (state = initialFilterState, action) => {
  switch (action?.type) {
    case types.CHANGE_FILTER_PROFILE_SCOPE:
      const newFilterProfile = { ...action.filterProfile, scope: action.scope };
      const profileIdx = state.profiles.indexOf(
        state.profiles.find((fp) => fp.uuid === action.filterProfile.uuid),
      );
      return {
        ...state,
        profiles: [
          ...state.profiles.slice(0, profileIdx),
          newFilterProfile,
          ...state.profiles.slice(profileIdx + 1),
        ],
      };
    case types.LOAD_FILTER_PROFILES:
      return {
        ...state,
        profilesLoadStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_FILTER_PROFILES):
      const refAddedFilterProfile = selectFilterProfiles(
        action?.payload?.results,
      );
      return {
        ...state,
        profilesLoadStatus: STATUS.LOADED,
        profiles: refAddedFilterProfile,
      };
    case types.UPDATE_FILTER_PROFILE: {
      return {
        ...state,
        dropdownSelectedProfile: action.data,
        profilesUpdateStatus: STATUS.RUNNING,
      };
    }
    case types.CLEAR_FILTER_PROFILE:
      return {
        ...state,
        selectedProfile: null,
        appliedProfile: null,
      };
    case resolve(types.UPDATE_FILTER_PROFILE):
      const profile = JSON.parse(JSON.stringify(action?.payload));
      const index = state?.profiles?.findIndex(
        (p) => p?.uuid === profile?.uuid,
      );

      if (index < 0) return state;
      return {
        ...state,
        profilesUpdateStatus: STATUS.SUCCESS,
        profiles: [
          ...state?.profiles?.slice(0, index),
          { ...profile },
          ...state?.profiles?.slice(index + 1),
        ],
        originalFilterProfiles: [
          ...state.originalFilterProfiles.slice(0, index),
          { ...profile },
          ...state.originalFilterProfiles.slice(index + 1),
        ],
      };
    case types.SAVE_FILTER_PROFILE:
      return {
        ...state,
        profilesUpdateStatus: STATUS.RUNNING,
      };
    case resolve(types.SAVE_FILTER_PROFILE):
      const payload = JSON.parse(JSON.stringify(action?.payload));

      return {
        ...state,
        profilesUpdateStatus: STATUS.SUCCESS,
        profiles: [...state?.profiles, action?.payload],
        originalFilterProfiles: [...state?.profiles, payload],
        selectedProfile: action?.payload?.uuid,
      };
    case types.CHANGE_FILTER_PROFILE_NAME:
      return {
        ...state,
        profileChangedNameStatus: STATUS.RUNNING,
      };
    case resolve(types.CHANGE_FILTER_PROFILE_NAME):
      return {
        ...state,
        profileChangedNameStatus: STATUS.SUCCESS,
        selectedProfile: action?.payload?.uuid,
      };

    case types.SAVE_FILTER_PROFILE_LOCALLY:
      return {
        ...state,
        profilesUpdateStatus: STATUS.RUNNING,
      };
    case resolve(types.SAVE_FILTER_PROFILE_LOCALLY):
      return {
        ...state,
        profilesUpdateStatus: STATUS.SUCCESS,
        profiles: [...state?.profiles, action?.payload],
        selectedProfile: {
          uuid: action?.payload?.uuid,
          name: action?.payload?.name,
        },
      };

    case types.CHANGE_SELECTED_FILTER_PROFILE:
      return {
        ...state,
        dropdownSelectedProfile: action?.data,
      };

    case types.RESET_SELECTED_FILTER_PROFILE:
      return {
        ...state,
        dropdownSelectedProfile: action?.data,
      };

    case types.SET_ORIGINAL_FILTER_PROFILES:
      return {
        ...state,
        originalFilterProfiles: action?.data,
      };

    case types.APPLY_FILTERS:
      return {
        ...state,
        selectedProfile: action?.uuid,
        appliedProfile: JSON?.parse(JSON?.stringify(action?.uuid)),
      };
    case types.DELETE_FILTER_PROFILE: {
      const newProfiles = state?.profiles?.filter(
        (p) => p?.uuid !== action?.uuid,
      );
      return {
        ...state,
        profilesUpdateStatus: STATUS.SUCCESS,
        deleteProfileStatus: STATUS.RUNNING,
        profiles: newProfiles,
      };
    }
    case resolve(types.DELETE_FILTER_PROFILE):
      return {
        ...state,
        profilesUpdateStatus: STATUS.SUCCESS,
        deleteProfileStatus: STATUS.SUCCESS,
      };

    case types.DELETE_TAG: {
      return {
        ...state,
      };
    }
    case resolve(types.DELETE_TAG):
      const { id, selectedProfile } = action?.payload;
      const updatedTags = [
        ...state?.profiles[selectedProfile]?.tags?.filter(
          (el) => el?.id !== id,
        ),
      ];
      const updatedProfile = {
        ...state?.profiles[selectedProfile],
        tags: updatedTags,
      };
      const updatedProfiles = [...state?.profiles]?.map((profile) => {
        if (profile?.name === updatedProfile?.name) {
          return updatedProfile;
        } else {
          return profile;
        }
      });
      return {
        ...state,
        profiles: updatedProfiles,
      };
    default:
      return state;
  }
};
